import type { TFunction } from 'i18next'

/**
 * Each quarter maps to its own static translation key (rather than a templated `quarter_${quarter}`) so key
 * usage stays greppable for Lokalise sync and refactors.
 */
export const formatDefaultQuarterTriggerLabel = (quarter: number, year: number, t: TFunction): string | undefined => {
  switch (quarter) {
    case 1:
      return t('period_select.trigger_label.quarter_1', { year })

    case 2:
      return t('period_select.trigger_label.quarter_2', { year })

    case 3:
      return t('period_select.trigger_label.quarter_3', { year })

    case 4:
      return t('period_select.trigger_label.quarter_4', { year })

    default:
      return undefined
  }
}
